<script setup lang="ts">
defineProps<{
  nextDisabled: boolean;
  nextLabel: string;
}>();

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const emit = defineEmits<{
  next: [];
}>();
</script>

<template>
  <div class="Portraits__footer">
    <div
      class="Portraits__footer-row Portraits__footer-row--top"
    >
      <div class="Portraits__footer-spacer"></div>

      <button
        class="kiosk-button kiosk-button--arrow-right"
        :disabled="nextDisabled"
        data-testid="portraits-next"
        @click="emit('next')"
      >
        {{ nextLabel }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.Portraits__footer {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding: var(--portrait-order-footer-padding, 0 1.35rem);
  margin-top: 0;
  margin-bottom: var(--portrait-order-footer-margin-bottom, 0);
}

.Portraits__footer-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.Portraits__footer-row--top {
  justify-content: var(--portrait-order-footer-justify, space-between);
  margin-top: var(--portrait-order-footer-margin-top, 0);
}

.Portraits__footer-spacer {
  display: var(--portrait-order-footer-spacer-display, block);
  flex-grow: 1;
}
</style>
